import { attr, hasMany } from '@ember-data/model';
import ShModel from './sh-model';

export default ShModel.extend({
    name: attr(),
    code: attr(),
    profile: hasMany('profile', { async: false })
});
